export default "__VITE_ASSET__DrXv$Ezu__"